<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Orders', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
            <v-btn-toggle
                v-model="toggleOrderScope"
                class="ml-5 mr-6"
                dense
                mandatory
                rounded
            >
                <v-btn small active-class="warning--text"
                    >PENDING<v-chip
                        x-small
                        class="ml-1 pa-1"
                        color="warning"
                        text-color="white"
                        v-if="pendingOrdersCount > 0"
                        >{{ pendingOrdersCount }}</v-chip
                    ></v-btn
                >
                <v-btn small active-class="success--text">READY_TO_PICK</v-btn>
                <v-btn small active-class="grey--text">COMPELETED</v-btn>
                <v-btn small>All</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- order cart preview dialog -->
        <v-dialog v-model="orderCartPreviewListDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeOrderCartPreviewListDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Order Carts</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        rounded
                        outlined
                        class="mr-3"
                        :loading="isLoadingOrderCartPreview"
                        v-print="'#printMe'"
                        @click="updateSalesOrderPrintStatus(true)"
                        >Print</v-btn
                    >
                </v-toolbar>

                <v-card-text class="mx-0 px-0">
                    <OrderCartPreviewList
                        v-if="selectedOrderCartNodeIdList.length > 0"
                        :salesOrderCartNodeIdList="selectedOrderCartNodeIdList"
                        :loading.sync="isLoadingOrderCartPreview"
                    ></OrderCartPreviewList>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="mx-2"
                                    >receipt</v-icon
                                >Orders
                                <v-btn
                                    class="ml-5"
                                    small
                                    rounded
                                    :disabled="orderSyncButtonTimer > 0"
                                    color="warning"
                                    @click="syncOrderData()"
                                    >Synchronize
                                    <span v-if="orderSyncButtonTimer > 0"
                                        >({{ orderSyncButtonTimer }})</span
                                    ></v-btn
                                >
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-row justify="end" align="end">
                                        <v-text-field
                                            dense
                                            v-model="search"
                                            append-outer-icon="refresh"
                                            @click:append-outer="
                                                refreshCurrentPage()
                                            "
                                            label="Search"
                                            clearable
                                            hide-details
                                            class="mx-2"
                                            @keydown.enter="
                                                refreshCurrentPage()
                                            "
                                            @click:clear="onClearSearch()"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-switch
                                    v-model="hidePrinted"
                                    @change="onChangeHidePrinted()"
                                    label="Hide Printed"
                                    class="ml-3 font-weight-regular"
                                >
                                    Hide Printed
                                </v-switch>
                                <!-- <v-col cols="12" sm="4" md="3" lg="2">
                                    <v-menu
                                        ref="menu"
                                        v-model="orderDatePickerMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="orderDateRange"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="orderDateRange"
                                                label="Date Range"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="orderDateRange" range>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="orderDatePickerMenu = false"
                                            >Cancel</v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu.save(orderDateRange)"
                                            >OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>-->
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantSalesOrders
                                            .loading
                                    "
                                    :items="
                                        tenantSalesOrders
                                            ? tenantSalesOrders.edges
                                            : []
                                    "
                                    :options.sync="dataTableOptions"
                                    loading-text="Loading... Please wait"
                                    :server-items-length="
                                        tenantSalesOrders
                                            ? tenantSalesOrders.totalCount
                                            : 0
                                    "
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries.tenantSalesOrders
                                                .loading
                                    }"
                                >
                                    <template v-slot:item.warning="{ item }">
                                        <v-tooltip
                                            bottom
                                            v-if="
                                                item.node.orderStatus ===
                                                    'PENDING' &&
                                                    calculateDaysBetweenDays(
                                                        item.node
                                                            .orderLoadDate ||
                                                            item.node
                                                                .deliverDatePlanned,
                                                        today
                                                    ) <= 0 &&
                                                    calculateMinutesBetweenDatetimes(
                                                        item.node
                                                            .orderStatusDate,
                                                        new Date()
                                                    ) < 10
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                    v-on="on"
                                                    class="warning--text ma-0"
                                                    >notification_important</v-icon
                                                >
                                            </template>
                                            <span>Overtime</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            bottom
                                            v-if="
                                                item.node.salesOrderProductSet
                                                    .totalCount > 0
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                    v-on="on"
                                                    class="error--text ma-0"
                                                    >warning</v-icon
                                                >
                                            </template>
                                            <span>Config product</span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-slot:item.node.orderCreatedDate="{
                                            item
                                        }"
                                    >
                                        <span>{{
                                            item.node.orderCreatedDate
                                                | moment(
                                                    "utc",
                                                    "YYYY-MM-DD HH:mm"
                                                )
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.orderLoadDate="{
                                            item
                                        }"
                                    >
                                        <span
                                            v-if="
                                                item.node.orderStatus ===
                                                    'COMPLETED'
                                            "
                                            >{{
                                                (item.node.orderLoadDate ||
                                                    item.node
                                                        .deliverDatePlanned)
                                                    | moment(
                                                        "utc",
                                                        "YYYY-MM-DD HH:mm"
                                                    )
                                            }}</span
                                        >
                                        <span
                                            v-else-if="
                                                calculateDaysBetweenDays(
                                                    item.node.orderLoadDate ||
                                                        item.node
                                                            .deliverDatePlanned,
                                                    today
                                                ) < 0
                                            "
                                            class="error--text"
                                            >{{
                                                (item.node.orderLoadDate ||
                                                    item.node
                                                        .deliverDatePlanned)
                                                    | moment(
                                                        "utc",
                                                        "YYYY-MM-DD HH:mm"
                                                    )
                                            }}</span
                                        >
                                        <span
                                            v-else-if="
                                                calculateDaysBetweenDays(
                                                    item.node.orderLoadDate ||
                                                        item.node
                                                            .deliverDatePlanned,
                                                    today
                                                ) == 0
                                            "
                                            class="warning--text"
                                            >{{
                                                (item.node.orderLoadDate ||
                                                    item.node
                                                        .deliverDatePlanned)
                                                    | moment(
                                                        "utc",
                                                        "YYYY-MM-DD HH:mm"
                                                    )
                                            }}</span
                                        >
                                        <span v-else>{{
                                            (item.node.orderLoadDate ||
                                                item.node.deliverDatePlanned)
                                                | moment(
                                                    "utc",
                                                    "YYYY-MM-DD HH:mm"
                                                )
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.isOnhold="{ item }"
                                    >
                                        <v-icon
                                            v-if="item.node.isOnhold"
                                            color="error"
                                            >report</v-icon
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.orderStatus="{ item }"
                                    >
                                        <v-chip
                                            small
                                            v-if="
                                                item.node.orderStatus ===
                                                    'PENDING'
                                            "
                                            color="warning"
                                            >{{ item.node.orderStatus }}</v-chip
                                        >
                                        <v-chip
                                            small
                                            v-else-if="
                                                item.node.orderStatus ===
                                                    'READY_TO_PICK'
                                            "
                                            color="success"
                                            dark
                                            >{{ item.node.orderStatus }}</v-chip
                                        >
                                        <v-chip small v-else>{{
                                            item.node.orderStatus
                                        }}</v-chip>

                                        <span
                                            v-if="item.node.externalOrderStatus"
                                            :class="
                                                item.node.externalOrderStatus ==
                                                '3'
                                                    ? 'error--text ml-1'
                                                    : 'ml-1'
                                            "
                                            >/
                                            {{
                                                calculateExternalOrderStatusText(
                                                    item.node
                                                        .externalOrderStatus
                                                )
                                            }}</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.isPrinted="{ item }"
                                    >
                                        <v-icon
                                            v-if="item.node.isPrinted"
                                            color="success"
                                            >check_circle</v-icon
                                        >
                                        <v-icon v-else color="grey lighten-2"
                                            >check_circle_outline</v-icon
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.orderStatusDate="{
                                            item
                                        }"
                                    >
                                        <span>{{
                                            item.node.orderStatusDate
                                                | moment("from", new Date())
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            @click="goToOrderDetail(item.node.id)"
                                            :color="item.node.salesOrderProductSet.totalCount > 0 ? `primary` : `primary`"
                                        >View</v-btn>-->
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="printOrder(item.node)"
                                        >
                                            <v-icon>print</v-icon>
                                        </v-btn>
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                goToOrderDetail(item.node.id)
                                            "
                                        >
                                            <v-icon>launch</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import moment from "moment";
import OrderCartPreviewList from "@/components/sales/OrderCartPreviewList.vue";

export default {
    name: "order-list-page",
    components: {
        OrderCartPreviewList
    },

    apollo: {
        pendingOrdersCount: {
            query: gql`
                query pendingOrdersCount {
                    tenantSalesOrders(orderStatus_Iexact: "PENDING") {
                        totalCount
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantSalesOrders.totalCount,
            skip: false,
            pollInterval: 60000 // ms
        },
        tenantSalesOrders: {
            query: gql`
                query tenantSalesOrders(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderCreatedDate_Gte: DateTime
                    $orderCreatedDate_Lte: DateTime
                    $orderStatus_In: String
                    $isPrinted: Boolean
                    $search: String
                    $orderBy: String
                ) {
                    tenantSalesOrders(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        orderCreatedDate_Gte: $orderCreatedDate_Gte
                        orderCreatedDate_Lte: $orderCreatedDate_Lte
                        orderStatus_In: $orderStatus_In
                        isPrinted: $isPrinted
                        search: $search
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                salesOrderNo
                                orderCreatedDate
                                orderLoadDate
                                deliverDatePlanned
                                orderStatus
                                orderStatusDate
                                externalOrderStatus
                                isPrinted
                                totalProductQuantity
                                customer {
                                    id
                                    name
                                }
                                salesOrderCartSet {
                                    totalCount
                                    edges {
                                        node {
                                            id
                                        }
                                    }
                                }
                                salesOrderProductSet(
                                    product_IsPlantsConfigured_Iexact: false
                                ) {
                                    totalCount
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10
                    // orderStatus_In: this.orderStatusFilter
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantSalesOrders,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            // isLoadingActiveSalesOrders: false,
            search: "",

            orderCartPreviewListDialog: false,
            isLoadingOrderCartPreview: false,
            printingOrder: {},
            hidePrinted: false,
            selectedOrderCartNodeIdList: [],

            orderSyncButtonTimer: 0,
            orderSyncDisableSeconds: 300, // 5 minutes

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            pendingOrdersCount: 0,
            tenantSalesOrders: {},

            toggleOrderScope: 1,

            orderDatePickerMenu: false,
            orderDateRange: [],

            headers: [
                {
                    text: "",
                    value: "warning",
                    sortable: false
                },
                {
                    text: "Order No",
                    value: "node.salesOrderNo",
                    width: "110px",
                    sortable: true
                },
                {
                    text: "Customer",
                    value: "node.customer.name",
                    sortable: true
                },
                {
                    text: "Quantity",
                    value: "node.totalProductQuantity",
                    sortable: true
                },
                {
                    text: "Created Date",
                    value: "node.orderCreatedDate",
                    filterable: false,
                    sortable: true
                },
                {
                    text: "Delivery Date",
                    value: "node.orderLoadDate",
                    filterable: false,
                    sortable: true
                },
                {
                    text: "Status",
                    value: "node.orderStatus",
                    sortable: true
                },
                {
                    text: "Printed",
                    value: "node.isPrinted",
                    sortable: true
                },
                {
                    text: "Status Timer",
                    value: "node.orderStatusDate",
                    filterable: false,
                    sortable: true
                },
                {
                    text: "Action",
                    value: "action",
                    // width: "160px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // activeSalesOrders() {
        //     return this.$store.state.sales.activeSalesOrders;
        // },
        dateRangeText() {
            return this.orderDateRange.join(" ~ ");
        },
        today() {
            var _today = new Date();
            _today.setHours(0, 0, 0, 0); // remove time

            return _today;
        },
        orderStartDate() {
            var _date = new Date();

            return () => {
                return _date.addDays(-3);
            };
        },
        orderStatusFilter() {
            switch (this.toggleOrderScope) {
                case 0:
                    return "PENDING";
                case 1:
                    return "READY_TO_PICK";
                case 2:
                    return "COMPLETED";
                default:
                    return null;
            }
        }
    },
    watch: {
        // page(newValue, oldValue) {
        //     if (newValue > oldValue) {
        //         this.getNextPage();
        //     } else {
        //         this.getPrevPage();
        //     }
        // },
        // itemsPerPage() {
        //     this.refreshCurrentPage();
        // },
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        },
        toggleOrderScope(value) {
            if (value != null) {
                localStorage.setItem("toggleOrderScope", value);

                this.refreshCurrentPage();
            }
        }
    },
    created() {
        // this.initialize();
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        if (this.$route.query.filter === "pending") {
            this.toggleOrderScope = 0;
        } else if (localStorage.getItem("toggleOrderScope") != null) {
            this.toggleOrderScope = parseInt(
                localStorage.getItem("toggleOrderScope")
            );
        }

        if (localStorage.orderSyncLastTriggeredTimestamp) {
            this.orderSyncButtonTimer = Math.floor(
                (localStorage.orderSyncLastTriggeredTimestamp -
                    new Date().getTime()) /
                    1000 +
                    this.orderSyncDisableSeconds
            );
            if (this.orderSyncButtonTimer > 0) {
                const timeValue = setInterval(() => {
                    this.orderSyncButtonTimer = this.orderSyncButtonTimer - 1;

                    if (this.orderSyncButtonTimer <= 0) {
                        clearInterval(timeValue);
                    }
                }, 1000);
            }
        }
    },
    methods: {
        // initialize() {
        //     // this.fetchActiveSalesOrders();
        // },

        // fetchActiveSalesOrders() {
        //     // fetch plants
        //     this.isLoadingActiveSalesOrders = true;
        //     this.$store
        //         .dispatch("sales/fetchActiveSalesOrders")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingActiveSalesOrders = false));
        // },

        calculateDaysBetweenDays(day1, day2) {
            return moment(day1)
                .startOf("day")
                .diff(moment(day2), "day");
        },

        calculateMinutesBetweenDatetimes(datetime1, datetime2) {
            return moment(datetime1).diff(moment(datetime2), "minutes");
        },

        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        calculateExternalOrderStatusText(externalOrderStatusId) {
            switch (externalOrderStatusId) {
                case "1":
                    return "OPEN";
                case "2":
                    return "DELIVERED";
                case "3":
                    return "CANCELLED";
                default:
                    return externalOrderStatusId;
            }
        },

        onChangeHidePrinted() {
            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;
            var _isPrinted = null;

            if (this.hidePrinted) {
                _isPrinted = false;
            }

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantSalesOrders.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantSalesOrders.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.salesOrderNo":
                    _orderBy = "salesOrderNo";
                    break;
                case "node.customer.name":
                    _orderBy = "customerName";
                    break;
                case "node.totalProductQuantity":
                    _orderBy = "totalProductQuantity";
                    break;
                case "node.orderCreatedDate":
                    _orderBy = "orderCreatedDate";
                    break;
                case "node.orderLoadDate":
                    _orderBy = "orderLoadDate";
                    break;
                case "node.orderStatus":
                    _orderBy = "orderStatus";
                    break;
                case "node.orderStatusDate":
                    _orderBy = "orderStatusDate";
                    break;
                case "node.isPrinted":
                    _orderBy = "isPrinted";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            // if show all orders, sort by deliver date desc
            if (
                (!this.orderStatusFilter ||
                    this.orderStatusFilter == "COMPLETED") &&
                !_orderBy
            ) {
                _orderBy = "-orderLoadDate";
            }

            this.$apollo.queries.tenantSalesOrders.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                isPrinted: _isPrinted,
                orderBy: _orderBy,
                search: this.search,
                orderStatus_In: this.orderStatusFilter
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantSalesOrders.skip = false;
            this.$apollo.queries.tenantSalesOrders.refresh();

            // update this.page
            this.page = page;
        },

        ////// Print order
        printOrder(order) {
            // console.log(order);
            this.printingOrder = order;
            this.selectedOrderCartNodeIdList = [];
            this.selectedOrderCartNodeIdList = order.salesOrderCartSet.edges.map(
                item => item.node.id
            );
            this.orderCartPreviewListDialog = true;
        },

        closeOrderCartPreviewListDialog() {
            this.orderCartPreviewListDialog = false;
            // this.selectedOrderCartNodeId = null;
            this.printingOrder = {};
            this.selectedOrderCartNodeIdList = [];
            this.refreshCurrentPage();
        },

        updateSalesOrderPrintStatus(isPrinted) {
            // // if same, don't sent to backend
            // if (isPrinted == this.salesOrder.isPrinted) {
            //     return;
            // }

            this.isSavingOrderPrintStatus = true;

            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation updateSalesOrderPrintStatus(
                            $input: UpdateSalesOrderPrintStatusInput!
                        ) {
                            updateSalesOrderPrintStatus(input: $input) {
                                salesOrder {
                                    id
                                    isPrinted
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: this.printingOrder.id,
                            isPrinted: isPrinted
                        }
                    }
                })
                .then(response => {
                    // Result
                    // console.log(response.data);
                    // console.log(response.data.updateSalesOrderNote.salesOrder.note);

                    this.printingOrder.isPrinted =
                        response.data.updateSalesOrderPrintStatus.salesOrder.isPrinted;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;
                })
                .finally(() => {
                    this.isSavingOrderPrintStatus = false;
                });
        },

        goToOrderDetail(orderNodeId) {
            let routeData = this.$router.resolve({
                name: "order-detail",
                params: { id: orderNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        //TODO: call run adf pipeline
        // mutation Mutation {
        //     runAdfPipeline {
        //         success
        //     }
        // }

        syncOrderData() {
            // save timer
            this.orderSyncLastTriggeredTimestamp = new Date().getTime();
            localStorage.orderSyncLastTriggeredTimestamp = this.orderSyncLastTriggeredTimestamp;
            this.orderSyncButtonTimer = this.orderSyncDisableSeconds;
            const timeValue = setInterval(() => {
                this.orderSyncButtonTimer = this.orderSyncButtonTimer - 1;

                if (this.orderSyncButtonTimer <= 0) {
                    clearInterval(timeValue);
                }
            }, 1000);

            // call api to sync data
            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation runAdfPipeline {
                            runAdfPipeline {
                                success
                            }
                        }
                    `,
                    // Parameters
                    variables: {}
                })
                .then(() => {
                    // Result
                    // console.log(response.data);
                    // console.log(response.data.updateSalesOrderNote.salesOrder.note);
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;
                })
                .finally(() => {});
        }
    }
};
</script>